import React from 'react';
import gear from '../../assets/icons/gear.svg';

const GearIcon = ({ size = 24, title = 'Settings', ...props }) => {
  return (
    <img
      src={gear}
      width={size}
      height={size}
      alt={title}
      aria-label={title}
      {...props}
    />
  );
};

export default GearIcon;
